import React from 'react';
import { Col, Row } from '../../util_grid/grid.js';
import Layout_base from './layout-base.jsx';

/*
 * products: PropTypes.array,
 * title: PropTypes.string,
 * subtitle: PropTypes.string,
 * variant: PropTypes.oneOf(['simple', 'stacked', 'spotlight']),
 * backgroundColor: PropTypes.string,
 * store: PropTypes.object,
 */
class CustomLayout extends Layout_base {
  constructor(props) {
    super(props);
    this.state = {
      DynamicPageHeader: null,
      AnkeilerGrid: null,
    };
  }

  componentDidMount() {
    this.loadComponents();
    this.props.store.productsFill({ srcObj: this.ankeilerGrid });
  }

  loadComponents = () => {
    // Lazy import to prevent these components to be included in the main bundle
    import(/* webpackPreload: true */ '../../sec_dynamic-page-header/component')
      .then(comObj => this.setState({ DynamicPageHeader: comObj.default }));
    import(/* webpackPreload: true */ '../../sec_ankeiler-grid/component')
      .then(comObj => this.setState({ AnkeilerGrid: comObj.default }));
  };

  get dynamicHeader() {
    return this.props.components
      .find(component => component['component-type'] === 'DynamicPageHeader') || {};
  }

  get breadcrumbs() {
    return this.props.components
      .find(component => component['component-type'] === 'breadcrumb') || {};
  }

  get ankeilerGrid() {
    return this.props.components
      .find(component => component['component-type'] === 'ankeilerGrid') || {};
  }

  get defaults() {
    const { items = [] } = this.breadcrumbs;
    if (!items.length) {
      return { title: '', subtitle: '' };
    } else if (items.length === 1) {
      return { title: items[0].name, subtitle: '' };
    }
    return {
      title: items[items.length - 1].name,
      subtitle: items[items.length - 2].name,
    };
  }

  render() {
    const { productSelection = [], title, subtitle, variant, products = [], backgroundColor, backgroundImage, hiddenSubtitle } = this.dynamicHeader;
    const { DynamicPageHeader, AnkeilerGrid } = this.state;

    return (
      <div>
        {(!!this.dynamicHeader && DynamicPageHeader) && (
          <DynamicPageHeader
            {...this.props}
            hiddenSubtitle={hiddenSubtitle}
            title={title || this.defaults.title}
            subtitle={subtitle || this.defaults.subtitle}
            variant={variant}
            products={products}
            productSelection={productSelection}
            backgroundColor={backgroundColor}
            backgroundImage={backgroundImage}
          />
        )}
        {(!!this.ankeilerGrid?.items?.length > 0 && AnkeilerGrid) && (
          <div className="container">
            <Row>
              <Col xs={12}>
                <AnkeilerGrid store={this.props.store} {...this.ankeilerGrid} />
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }
}

export default CustomLayout;
